
class ManagerPermissionsDataSource extends MIOObject
{
    private tableView:UITableView = null;
    initWithTableView(tableView:UITableView){
        this.tableView = tableView;
    }

    private _user:User = null;
    get user(){return this._user;}
    set user(value:User) {
        this._user = value;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    titleForHeaderInSection(tableView:MUITableView, section:number) {
        let ip = MIOIndexPath.indexForRowInSection(0, section);
        let item = this.fetchedResultsController.objectAtIndexPath(ip) as ManagerSectionLocalized;
        return item.module;
    }

    cellAtIndexPath(tableView:UITableView, indexPath: MIOIndexPath) {
        let cell = tableView.dequeueReusableCellWithIdentifier("UserPermissionCell") as UserPermissionCell;
        
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ManagerSectionLocalized;
        cell.title = item.name
        cell.sectionIndex = item.managerSection.bitPosition;
        cell.accessoryType = this._user.hasManagerPermision(item.managerSection.bitPosition) ? UITableViewCellAccessoryType.Checkmark : UITableViewCellAccessoryType.None;
        
        cell.delegate = this;

        return cell;
    }

    canSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ManagerSectionLocalized;

        let loginEmail = MIOUserDefaults.standardUserDefaults().valueForKey("LastLoginEmail");
        if (this._user.email == loginEmail && item.managerSection.bitPosition == 47) return false;

        return true;
    }    

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.cellAtIndexPath(indexPath) as UserPermissionCell;

        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ManagerSectionLocalized;
        
        if (this._user.hasManagerPermision(item.managerSection.bitPosition)) {
            // Remove
            this._user.removeManagerPermission(item.managerSection.bitPosition);
            cell.accessoryType = UITableViewCellAccessoryType.None;
        }
        else {
            this._user.addManagerPermission(item.managerSection.bitPosition);
            cell.accessoryType = UITableViewCellAccessoryType.Checkmark;
        }        
    }

    private _fetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
    
        let fetchRequest = MIOFetchRequest.fetchRequestWithEntityName('ManagerSectionLocalized');
        fetchRequest.sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey('managerSection.moduleIndex', true),
                                        MIOSortDescriptor.sortDescriptorWithKey('managerSection.orderIndex', true)];
        fetchRequest.relationshipKeyPathsForPrefetching = ["managerSection"];
            
        let predicateValues = ["language = '" + SettingsHelper.sharedInstance().currentSupportedLanguage + "'"];
                
        if (predicateValues.length > 0) fetchRequest.predicate = MIOPredicate.predicateWithFormat(predicateValues.join(" AND "));

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, "managerSection.moduleIndex");
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();
    
        this._fetchedResultsController = fetchedResultsController;    
        return this._fetchedResultsController;
    }
    
    controllerDidChangeContent(controller:MIOFetchedResultsController){        
        this.tableView.reloadData();
    }
}